import { GridItem, Heading, Link, List, ListItem } from '@chakra-ui/react';
import type { IMenuGroup } from '../types';

interface IMenuGroupProps extends IMenuGroup {}

export const MenuGroup: React.FC<IMenuGroupProps> = (props): JSX.Element => {
  const { heading, items } = props;
  return (
    <GridItem>
      <List spacing={3}>
        <ListItem>
          <Heading fontSize={{ base: 'large', md: 'h4' }} fontWeight="medium">
            {heading}
          </Heading>
        </ListItem>
        {items.map((item) => (
          <ListItem key={`menuItem-${item.id}`}>
            <Link fontSize={{ base: 'medium', md: 'large' }} href={item.href} target={item.target}>
              {item.label}
            </Link>
          </ListItem>
        ))}
      </List>
    </GridItem>
  );
};
